import { type TranslationTree } from '@/i18n/types';

export const messages = {
  postalCode: 'CEP',
  postalCodeHint: 'Preenche rua, bairro, cidade e UF',
  optional: 'opcional',
  street: 'Rua ou local',
  number: 'Número',
  complement: 'Complemento',
  complementPlaceholder: 'Ponto de encontro, portão, quiosque',
  neighborhood: 'Bairro',
  city: 'Cidade',
  state: 'UF',
} satisfies TranslationTree;
